import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import CompaniesDropdown from '../companies/companies-dropdown.jsx';
import CurrencyInput from 'react-currency-input';
import {Animate} from 'react-simple-animate';

export default class AddNewCustomer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      companies: props.companiesAll || [],
      selectedCustomerId: null,
      visible: false,
      pricing_mile_fixed_price_in_pence_1: 0,
      pricing_mile_fixed_price_in_pence_2: 0,
      pricing_mile_fixed_price_in_pence_3: 0,
      pricing_mile_fixed_price_in_pence_4: 0,
      value_of_jobs_per_invoice_in_pence: 0,
      play: false
    };
    this.onAddNewCustomerCreate = this.onAddNewCustomerCreate.bind(this);
    this.toggleAddNewCustomer = this.toggleAddNewCustomer.bind(this);
    this.copyMainAddressToInvoiceAddress = this.copyMainAddressToInvoiceAddress.bind(this);
  }
  handleCustomerSelection(option) {
    this.setState({selectedCustomerId: option.id});
  }

  toggleAddNewCustomer(e) {
    $('#add_new_customer_form').slideToggle();
    $('.add-new-customer-button').
    toggleClass('text-center').
    toggleClass('opened-button-for-slidedown-content');
    $('#slide-toggle-icon').
    toggleClass('fa-minus-circle');
    $('#react-component-g4-logistics-portal-customers-add-new-customer').
    toggleClass('active');
  }

  copyMainAddressToInvoiceAddress(e) {
    e.preventDefault();
    $('[name=customer_invoice_address_postcode]').val(
      $('[name=customer_main_address_postcode]').val());
    $('[name=customer_invoice_address_house_number_or_name]').val(
      $('[name=customer_main_address_house_number_or_name]').val());
    $('[name=customer_invoice_address_address_line_1]').val(
      $('[name=customer_main_address_address_line_1]').val());
    $('[name=customer_invoice_address_address_line_2]').val(
      $('[name=customer_main_address_address_line_2]').val());
    $('[name=customer_invoice_address_address_line_3]').val(
      $('[name=customer_main_address_address_line_3]').val());
    $('[name=customer_invoice_address_town_city]').val(
      $('[name=customer_main_address_town_city]').val());
    $('[name=customer_invoice_address_county_area]').val(
      $('[name=customer_main_address_county_area]').val());
    $('[name=customer_invoice_address_country]').val(
      $('[name=customer_main_address_country]').val());
  }

  onAddNewCustomerCreate(e) {
    e.preventDefault();
    let customer = '#add_new_customer_form ';
    let newCustomerData = {
      api_token: window.api_token,
      company_id: $('[name=company-id]').val(),
      name: document.querySelector(
        customer+
        '[name=customer_name]'
      ).value,
      vat_number: document.querySelector(
        customer+
        '[name=customer_vat_number]'
      ).value,
      reg_number: document.querySelector(
        customer+
        '[name=customer_reg_number]'
      ).value,
      telephone_1: document.querySelector(
        customer+
        '[name=customer_telephone_1]'
      ).value,
      telephone_2: document.querySelector(
        customer+
        '[name=customer_telephone_2]'
      ).value,
      sage_account_reference: document.querySelector(
        customer+
        '[name=customer_sage_account_reference]'
      ).value,
      contact_first_name: document.querySelector(
        customer+
        '[name=customer_contact_first_name]'
      ).value,
      contact_last_name: document.querySelector(
        customer+
        '[name=customer_contact_last_name]'
      ).value,
      contact_email: document.querySelector(
        customer+
        '[name=customer_contact_email]'
      ).value,
      contact_password: document.querySelector(
        customer+
        '[name=customer_contact_password]'
      ).value,
      contact_telephone_1: document.querySelector(
        customer+
        '[name=customer_contact_telephone_1]'
      ).value,
      contact_telephone_2: document.querySelector(
        customer+
        '[name=customer_contact_telephone_2]'
      ).value,
      customer_special_instruction: document.querySelector(
        customer+
        '[name=customer_special_instruction]'
      ).value,
      add_multiple_email_addresses_of_people: document.querySelector(
        customer+
        '[name=add_multiple_email_addresses_of_people]'
      ).value,
      main_address: {
        postcode: document.querySelector(
          customer+
          '[name=customer_main_address_postcode]'
        ).value,
        house_number_or_name: document.querySelector(
          customer+
          '[name=customer_main_address_house_number_or_name]'
        ).value,
        address_line_1: document.querySelector(
          customer+
          '[name=customer_main_address_address_line_1]'
        ).value,
        address_line_2: document.querySelector(
          customer+
          '[name=customer_main_address_address_line_2]'
        ).value,
        address_line_3: document.querySelector(
          customer+'[name=customer_main_address_address_line_3]'
        ).value,
        town_city: document.querySelector(
          customer+
          '[name=customer_main_address_town_city]'
        ).value,
        county_area: document.querySelector(
          customer+
          '[name=customer_main_address_county_area]'
        ).value,
        country: document.querySelector(
          customer+
          '[name=customer_main_address_country]'
        ).value,
      },
      invoice_address: {
        postcode: document.querySelector(
          customer+
          '[name=customer_invoice_address_postcode]'
        ).value,
        house_number_or_name: document.querySelector(
          customer+
          '[name=customer_invoice_address_house_number_or_name]'
        ).value,
        address_line_1: document.querySelector(
          customer+
          '[name=customer_invoice_address_address_line_1]'
        ).value,
        address_line_2: document.querySelector(
          customer+
          '[name=customer_invoice_address_address_line_2]'
        ).value,
        address_line_3: document.querySelector(
          customer+
          '[name=customer_invoice_address_address_line_3]'
        ).value,
        town_city: document.querySelector(
          customer+
          '[name=customer_invoice_address_town_city]'
        ).value,
        county_area: document.querySelector(
          customer+
          '[name=customer_invoice_address_county_area]'
        ).value,
        country: document.querySelector(
          customer+
          '[name=customer_invoice_address_country]'
        ).value,
      },
      manual_appraisal_required: document.querySelector(
        customer+
        '#manual-appraisal-required-form-radio-container '+
        'label.active [name=manual_appraisal_required]'
      ).value,
      video_appraisal_required: document.querySelector(
        customer+
        '#video-appraisal-required-form-radio-container '+
        'label.active [name=video_appraisal_required]'
      ).value,
      appraisal_to_be_done_on_external_system: document.querySelector(
        customer+
        '#appraisal-to-be-done-on-external-system-form-radio-container '+
        'label.active [name=appraisal_to_be_done_on_external_system]'
      ).value,
      customer_vat_code: document.querySelector(customer+'#customer-vat-code-form-radio-container '+'label.active [name=customer_vat_code]').value,
      name_of_external_system_for_appraisal: document.querySelector(
        customer+
        '[name=name_of_external_system_for_appraisal]'
      ) ? document.querySelector(
        customer+
        '[name=name_of_external_system_for_appraisal]'
      ).value : null,
      new_job_defaults_fleet_paperwork_required: document.querySelector(
        customer+
        '#fleet-paperwork-form-radio-container label.active '+
        '[name=vehicle_fleet_paperwork_required]'
      ).value,
      new_job_defaults_jet_wash_required: document.querySelector(
        customer+
        '#jet-wash-form-radio-container label.active '+
        '[name=vehicle_jet_wash_required]'
      ).value,
      new_job_defaults_driver_fuel_expense_included_in_job_price: document.
      querySelector(
        customer+
        '#driver-fuel-expense-included-in-job-price-form-radio-container '+
        'label.active [name=driver_fuel_expense_included_in_job_price]'
      ).value,
      new_job_defaults_customer_provides_fuel_cost: document.
      querySelector(
        customer+
        '#customer-provides-fuel-cost-form-radio-container '+
        'label.active [name=customer_provides_fuel_cost]'
      ).value,
      new_job_defaults_customer_provides_mileage: document.querySelector(
        customer+
        '#customer-provides-mileage-form-radio-container label.active '+
        '[name=customer_provides_mileage]'
      ).value,
      new_job_defaults_customer_provides_job_price: document.querySelector(
        customer+
        '#customer-provides-job-price-form-radio-container label.active '+
        '[name=customer_provides_job_price]'
      ).value,
      new_job_defaults_job_price_rounded_up: document.querySelector(
        customer+
        '#job-price-rounded-up-form-radio-container label.active '+
        '[name=job_price_rounded_up]'
      ).value,
      new_job_defaults_customer_needs_expenses: {
        pod: (document.querySelector(customer+'#customer-needs-expenses-form-radio-container label.active  '+'[name=customer_needs_expenses_pod]')) ? (document.querySelector(customer+'#customer-needs-expenses-form-radio-container label.active  '+'[name=customer_needs_expenses_pod]').value) : '',
        poc: (document.querySelector(customer+'#customer-needs-expenses-form-radio-container label.active  '+'[name=customer_needs_expenses_poc]')) ? (document.querySelector(customer+'#customer-needs-expenses-form-radio-container label.active  '+'[name=customer_needs_expenses_poc]').value) : '',
        fuel: (document.querySelector(customer+'#customer-needs-expenses-form-radio-container label.active  '+'[name=customer_needs_expenses_fuel]')) ? (document.querySelector(customer+'#customer-needs-expenses-form-radio-container label.active  '+'[name=customer_needs_expenses_fuel]').value) : '',
        all_expense: (document.querySelector(customer+'#customer-needs-expenses-form-radio-container label.active  '+'[name=customer_needs_expenses_all]')) ? (document.querySelector(customer+'#customer-needs-expenses-form-radio-container label.active  '+'[name=customer_needs_expenses_all]').value) : '',
      },
      pricing_mile_start_1: document.querySelector(
        customer+
        '[name=pricing_mile_start_1]').value,
      pricing_mile_start_2: document.querySelector(
        customer+
        '[name=pricing_mile_start_2]').value,
      pricing_mile_start_3: document.querySelector(
        customer+
        '[name=pricing_mile_start_3]').value,
      pricing_mile_start_4: document.querySelector(
        customer+
        '[name=pricing_mile_start_4]').value,
      pricing_mile_end_4: document.querySelector(
        customer+
        '[name=pricing_mile_end_4]').value,
      pricing_mile_end_2: document.querySelector(
        customer+
        '[name=pricing_mile_end_2]').value,
      pricing_mile_end_3: document.querySelector(
        customer+
        '[name=pricing_mile_end_3]').value,
      pricing_mile_end_1: document.querySelector(
        customer+
        '[name=pricing_mile_end_1]').value,
      pricing_mile_pence_1: document.querySelector(
        customer+
        '[name=pricing_mile_pence_1]').value,
      pricing_mile_pence_2: document.querySelector(
        customer+
        '[name=pricing_mile_pence_2]').value,
      pricing_mile_pence_3: document.querySelector(
        customer+
        '[name=pricing_mile_pence_3]').value,
      pricing_mile_pence_4: document.querySelector(
        customer+
        '[name=pricing_mile_pence_4]').value,

      pricing_mile_fixed_price_in_pence_1: this.
        state.pricing_mile_fixed_price_in_pence_1,
      pricing_mile_fixed_price_in_pence_2: this.
        state.pricing_mile_fixed_price_in_pence_2,
      pricing_mile_fixed_price_in_pence_3: this.
        state.pricing_mile_fixed_price_in_pence_3,
      pricing_mile_fixed_price_in_pence_4: this.
        state.pricing_mile_fixed_price_in_pence_4,

      value_of_jobs_per_invoice_in_pence: this.state.
        value_of_jobs_per_invoice_in_pence,

      number_of_jobs_per_invoice: document.querySelector(
        customer+
        '[name=number_of_jobs_per_invoice]').value,
      auto_subscriber_email:   document.querySelector(
            customer+'[name=auto_subscriber_email]').value 
    };

    $.ajax({
      type: "POST",
      url: '/api/v1/portal/customers/add-new-customer',
      data: newCustomerData,
      dataType: "text/json",
      complete: function(response) {
        if (response.status == 200) {
          $('#infomodallabel').html('New Customer Created');
          $('#infomodal .modal-body').html('New Customer Created');
          $('#infomodal').modal();
          $('input').val('');
          $('textarea').val('');
          $('select').val('');
        }
        else {
          $('#infomodallabel').html('Error adding new customer');
          $('#infomodal .modal-body').html(
            $.parseHTML(response.responseText.replace(/\"/g, ""))
          );
          $('#infomodal').modal();
        }
      }
    });
  }

  render() {
    return (
      <div>
        <button
          className="text-center btn btn-lg btn-light add-new-customer-button"
          type="button"
          onClick={this.toggleAddNewCustomer}>
          <i
            className="fa fa-plus-circle"
            id="slide-toggle-icon"></i>&nbsp;
          Add New Customer
        </button>
        <form
          id="add_new_customer_form"
          ref="addNewCustomerForm">
          <fieldset>
            <div className="row">
              <div className="col-md-12">
                <h1 className="text-center">
                  Adding New Customer
                </h1>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="customer_name">
                    Company Name:
                  </label>
                  <input
                    type="text"
                    name="customer_name" required
                    id="customer_name"
                    className="form-control form-control-lg" />
                </div>

                <div className="form-group">
                  <label htmlFor="customer_name">
                    Company that this customer belongs to:
                  </label>
                  <CompaniesDropdown />
                </div>

                <div className="form-group">
                  <label htmlFor="customer_telephone_1">
                    Customer Telephone 1:
                  </label>
                  <input
                    type="text"
                    name="customer_telephone_1" required
                    id="customer_telephone_1"
                    className="form-control form-control-lg" />
                </div>
                <div className="form-group">
                  <label htmlFor="customer_telephone_2">
                    Customer Telephone 2:
                  </label>
                  <input
                    type="text"
                    name="customer_telephone_2"
                    id="customer_telephone_2"
                    className="form-control form-control-lg" />
                </div>
                <div className="form-group">
                  <label htmlFor="customer_vat_number">
                    Customer VAT Number:
                  </label>
                  <input
                    type="text"
                    name="customer_vat_number"
                    id="customer_vat_number"
                    className="form-control form-control-lg" />
                </div>
                <div className="form-group">
                  <label htmlFor="customer_reg_number">
                  Company Registration Number:
                  </label>
                  <input
                    type="text"
                    name="customer_reg_number"
                    id="customer_reg_number"
                    className="form-control form-control-lg" />
                </div>
                <div className="form-group">
                  <label htmlFor="customer_sage_account_reference">
                  Accounts reference number:
                  </label>
                  <input
                    type="text"
                    name="customer_sage_account_reference" required
                    id="customer_sage_account_reference"
                    className="form-control form-control-lg" />
                </div>
              </div>

              <div className="col-md-6">
                <div className="contact-box">
                  <div className="row">
                    <div className="col-md-12">
                      <h3 className="add-some-padding">
                        Contact for New Customer
                      </h3>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="customer_contact_first_name">
                              Contact First Name:
                            </label>
                            <input
                              type="text"
                              name="customer_contact_first_name" required
                              id="customer_contact_first_name"
                              className="form-control form-control-lg" />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="customer_contact_last_name">
                            Contact Last Name:
                          </label>
                          <input
                            type="text"
                            name="customer_contact_last_name" required
                            id="customer_contact_last_name"
                            className="form-control form-control-lg" />
                        </div>
                      </div>
                      <div className="form-group">
                        <label htmlFor="customer_contact_email">
                          Contact Email:
                        </label>
                        <input
                          type="text"
                          name="customer_contact_email" required
                          id="customer_contact_email"
                          className="form-control form-control-lg" />
                      </div>
                      <div className="form-group">
                        <label htmlFor="customer_contact_password">
                          Contact Password:
                        </label>
                        <input
                          type="text"
                          name="customer_contact_password" required
                          id="customer_contact_password"
                          className="form-control form-control-lg" />
                      </div>
                      <div className="form-group">
                        <label htmlFor="customer_contact_telephone_1">
                          Contact Telephone 1:
                        </label>
                        <input
                          type="text"
                          name="customer_contact_telephone_1" required
                          id="customer_contact_telephone_1"
                          className="form-control form-control-lg" />
                      </div>
                      <div className="form-group">
                        <label htmlFor="customer_contact_telephone_2">
                          Contact Telephone 2:
                        </label>
                        <input
                          type="text"
                          name="customer_contact_telephone_2"
                          id="customer_contact_telephone_2"
                          className="form-control form-control-lg" />
                      </div>
                      <div className="form-group">
                        <label htmlFor="customer_contact_telephone_2">
                          Special Instruction:
                        </label>
                          <textarea className="form-control form-control-lg"
                                    name="customer_special_instruction"
                                    id="customer_special_instruction">
                          </textarea>
                      </div>
                      <div className="form-group">
                        <label htmlFor="add_multiple_email_addresses_of_people">
                          Multiple Email adderesses of people:
                        </label>
                          <textarea className="form-control form-control-lg"
                                    name="add_multiple_email_addresses_of_people"
                                    id="add_multiple_email_addresses_of_people">
                          </textarea>
                          <label htmlFor="add_multiple_email_addresses_of_people">
                          Please separate different mail address with comma(,)
                          </label>
                      </div>
                      <div className="form-group">
                        <label htmlFor="auto_subscriber_email">
                          Auto Subscribe Emails:
                        </label>
                        <textarea className="form-control form-control-lg"
                          name="auto_subscriber_email"
                          id="auto_subscriber_email">
                        </textarea>
                        <label htmlFor="auto_subscriber_email">
                          Please separate different mail address with comma(,)(,)
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <br />

            <div className="row">
              <div className="col-md-6">
                <h3>Main Address</h3>
                <div className="form-group address-finder">
                  Address Finder:
                  <div id="customer_main_address_postcode_lookup"></div>
                </div>
                <div className="form-group">
                  <label htmlFor="customer_main_address_house_number_or_name">
                    House Number or Name:
                  </label>
                  <input
                    type="text"
                    name="customer_main_address_house_number_or_name"
                    id="customer_main_address_house_number_or_name"
                    className="form-control form-control-lg" />
                </div>

                <div className="form-group">
                  <label htmlFor="customer_main_address_address_line_1">
                    Address Line 1:
                  </label>
                  <input
                    type="text"
                    name="customer_main_address_address_line_1" required
                    id="customer_main_address_address_line_1"
                    className="form-control form-control-lg" />
                </div>

                <div className="form-group">
                  <label htmlFor="customer_main_address_address_line_2">
                    Address Line 2:
                  </label>
                  <input
                    type="text"
                    name="customer_main_address_address_line_2"
                    id="customer_main_address_address_line_2"
                    className="form-control form-control-lg" />
                </div>

                <div className="form-group">
                  <label htmlFor="customer_main_address_address_line_3">
                    Address Line 3:
                  </label>
                  <input
                    type="text"
                    name="customer_main_address_address_line_3"
                    id="customer_main_address_address_line_3"
                    className="form-control form-control-lg" />
                </div>

                <div className="form-group">
                  <label htmlFor="customer_main_address_town_city">
                    Town/City:
                  </label>
                  <input
                    type="text"
                    name="customer_main_address_town_city"
                    id="customer_main_address_town_city"
                    className="form-control form-control-lg" />
                </div>

                <div className="form-group">
                  <label htmlFor="customer_main_address_county_area">
                    County/Area
                  </label>
                  <input
                    type="text"
                    name="customer_main_address_county_area"
                    id="customer_main_address_county_area"
                    className="form-control form-control-lg" />
                </div>

                <div className="form-group">
                  <label htmlFor="customer_main_address_country">
                    Country:
                  </label>
                  <input
                    type="text"
                    name="customer_main_address_country"
                    id="customer_main_address_country"
                    className="form-control form-control-lg" />
                </div>

                <div className="form-group">
                  <label htmlFor="customer_main_address_postcode">
                    Postcode:
                  </label>
                  <input
                    type="text"
                    name="customer_main_address_postcode" required
                    id="customer_main_address_postcode"
                    className="form-control form-control-lg" />
                </div>
              </div>

              <div className="col-md-6">
                <h3>
                  Invoice Address
                  <button
                    onClick={this.copyMainAddressToInvoiceAddress}
                    className="btn same-as-main-address">
                    Same as Main Address
                  </button>
                </h3>
                <div className="form-group address-finder">
                  Address Finder:
                  <div id="customer_invoice_address_postcode_lookup"></div>
                </div>

                <div className="form-group">
                  <label htmlFor="customer_invoice_address_house_number_or_name">
                    House Number or Name:
                  </label>
                  <input
                    type="text"
                    name="customer_invoice_address_house_number_or_name"
                    id="customer_invoice_address_house_number_or_name"
                    className="form-control form-control-lg" />
                </div>

                <div className="form-group">
                  <label htmlFor="customer_invoice_address_address_line_1">
                    Address Line 1:
                  </label>
                  <input
                    type="text"
                    name="customer_invoice_address_address_line_1" required
                    id="customer_invoice_address_address_line_1"
                    className="form-control form-control-lg" />
                </div>

                <div className="form-group">
                  <label htmlFor="customer_invoice_address_line_2">
                    Address Line 2:
                  </label>
                  <input
                    type="text"
                    name="customer_invoice_address_address_line_2"
                    id="customer_invoice_address_address_line_2"
                    className="form-control form-control-lg" />
                </div>

                <div className="form-group">
                  <label htmlFor="customer_invoice_address_line_3">
                    Address Line 3:
                  </label>
                  <input
                    type="text"
                    name="customer_invoice_address_address_line_3"
                    id="customer_invoice_address_address_line_3"
                    className="form-control form-control-lg" />
                </div>

                <div className="form-group">
                  <label htmlFor="customer_invoice_address_town_city">
                    Town/City:
                  </label>
                  <input
                    type="text"
                    name="customer_invoice_address_town_city"
                    id="customer_invoice_address_town_city"
                    className="form-control form-control-lg" />
                </div>

                <div className="form-group">
                  <label htmlFor="customer_invoice_address_county_area">
                    County/Area
                  </label>
                  <input
                    type="text"
                    name="customer_invoice_address_county_area"
                    id="customer_invoice_address_county_area"
                    className="form-control form-control-lg" />
                </div>

                <div className="form-group">
                  <label htmlFor="customer_invoice_address_country">
                    Country:
                  </label>
                  <input
                    type="text"
                    name="customer_invoice_address_country"
                    id="customer_invoice_address_country"
                    className="form-control form-control-lg" />
                </div>
                <div className="form-group">
                  <label htmlFor="customer_invoice_address_postcode">
                    Postcode:
                  </label>
                  <input
                    type="text"
                    name="customer_invoice_address_postcode" required
                    id="customer_invoice_address_postcode"
                    className="form-control form-control-lg" />
                </div>
              </div>
            </div>

            <br />
            <hr />

            <div className="row text-center">
              <div className="col-md-12">
                <h3 className="text-center">
                  Pricing Settings
                </h3>
                <div className="row">
                  <div className="col-md-3">
                    Mile Start
                  </div>
                  <div className="col-md-1"></div>
                  <div className="col-md-3">
                    Mile End
                  </div>
                  <div className="col-md-1"></div>
                  <div className="col-md-2 text-left">
                    Pence per Mile
                  </div>
                  <div className="col-md-2 text-right">
                    Fixed Price
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control form-control-lg text-center text-center"
                      required name="pricing_mile_start_1" />
                  </div>
                  <div className="col-md-1"> to </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control form-control-lg text-center text-center"
                      required name="pricing_mile_end_1" />
                  </div>
                  <div className="col-md-1"> = </div>
                  <div className="col-md-2 text-center">
                    <input
                      type="text"
                      className="form-control form-control-lg text-center text-center"
                      required name="pricing_mile_pence_1" />
                  </div>
                  <div className="col-md-2 text-center">
                    <CurrencyInput
                      type="text"
                      name="funds"
                      value={this.state.pricing_mile_fixed_price_in_pence_1/100}
                      prefix={'£'}
                      type='text'
                      allowNegative={true}
                      className="form-control form-control-lg form-control-currency"
                      onChangeEvent={
                        (event, maskedValue, floatValue) => {
                          this.setState({
                            pricing_mile_fixed_price_in_pence_1: (floatValue*100),
                          });
                        }
                      }
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control form-control-lg text-center"
                      name="pricing_mile_start_2" />
                  </div>
                  <div className="col-md-1"> to </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control form-control-lg text-center"
                      name="pricing_mile_end_2" />
                  </div>
                  <div className="col-md-1"> = </div>
                  <div className="col-md-2 text-center">
                    <input
                      type="text"
                      className="form-control form-control-lg text-center text-center"
                      required name="pricing_mile_pence_2" />
                  </div>
                  <div className="col-md-2 text-center">
                    <CurrencyInput
                      type="text"
                      name="funds"
                      value={this.state.pricing_mile_fixed_price_in_pence_2/100}
                      prefix={'£'}
                      type='text'
                      allowNegative={true}
                      className="form-control form-control-lg form-control-currency"
                      onChangeEvent={
                        (event, maskedValue, floatValue) => {
                          this.setState({
                            pricing_mile_fixed_price_in_pence_2: (floatValue*100),
                          });
                        }
                      }
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control form-control-lg text-center"
                      name="pricing_mile_start_3" />
                  </div>
                  <div className="col-md-1"> to </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control form-control-lg text-center"
                      name="pricing_mile_end_3" />
                  </div>
                  <div className="col-md-1"> = </div>
                  <div className="col-md-2 text-center">
                    <input
                      type="text"
                      className="form-control form-control-lg text-center text-center"
                      required name="pricing_mile_pence_3" />
                  </div>
                  <div className="col-md-2 text-center">
                    <CurrencyInput
                      type="text"
                      name="funds"
                      value={this.state.pricing_mile_fixed_price_in_pence_3/100}
                      prefix={'£'}
                      type='text'
                      allowNegative={true}
                      className="form-control form-control-lg form-control-currency"
                      onChangeEvent={
                        (event, maskedValue, floatValue) => {
                          this.setState({
                            pricing_mile_fixed_price_in_pence_3: (floatValue*100),
                          });
                        }
                      }
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control form-control-lg text-center"
                      name="pricing_mile_start_4" />
                  </div>
                  <div className="col-md-1"> to </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control form-control-lg text-center"
                      name="pricing_mile_end_4" />
                  </div>
                  <div className="col-md-1"> = </div>
                  <div className="col-md-2 text-center">
                    <input
                      type="text"
                      className="form-control form-control-lg text-center text-center"
                      required name="pricing_mile_pence_4" />
                  </div>
                  <div className="col-md-2 text-center">
                    <CurrencyInput
                      type="text"
                      name="funds"
                      value={this.state.pricing_mile_fixed_price_in_pence_4/100}
                      prefix={'£'}
                      type='text'
                      allowNegative={true}
                      className="form-control form-control-lg form-control-currency"
                      onChangeEvent={
                        (event, maskedValue, floatValue) => {
                          this.setState({
                            pricing_mile_fixed_price_in_pence_4: (floatValue*100),
                          });
                        }
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            <br />
            <hr />

            <div className="row">
              <div className="col-md-12">
                <h3 className="text-center">Invoice Settings</h3>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
            <div className="row">
              <div className="col-md-6 text-right">
                Number of Jobs per invoice:
              </div>
              <div className="col-md-6">
                <input
                  type="text"
                  className="form-control form-control-lg"
                  name="number_of_jobs_per_invoice"
                  placeholder="any"
                />
              </div>
            </div>
              </div>
              <div className="col-md-6">

            <div className="row">
              <div className="col-md-6 text-right">
                Value of Jobs per invoice:
              </div>
              <div className="col-md-6">
                Value of Jobs per invoice:
                <CurrencyInput
                  type="text"
                  name="funds"
                  value={this.state.value_of_jobs_per_invoice_in_pence/100}
                  prefix={'£'}
                  type='text'
                  allowNegative={true}
                  className="form-control form-control-lg form-control-currency"
                  onChangeEvent={
                    (event, maskedValue, floatValue) => {
                      this.setState({
                        value_of_jobs_per_invoice_in_pence: (
                          floatValue*100
                        )
                      });
                    }
                  }
                />
              </div>
            </div>
              </div>
            </div>
            <br />
            <hr />
            <div className="row">
              <div className="col-md-12">
                <h3 className="text-center">Defaults for New Jobs</h3>
                <br />
              </div>
            </div>
            <div className="row text-center">
              <div className="col-md-4">
                <div className="form-group">
                  <label>
                    Driver Fuel Expense Included in Job Price?
                  </label>

                  <div className="btn-group btn-group-toggle"
                       id="driver-fuel-expense-included-in-job-price-form-radio-container"
                       data-toggle="buttons">
                    <label className="btn btn-secondary"
                           id="yes-driver-fuel-expense-included-in-job-price">
                      <input className="form-control form-control-lg"
                             name="driver_fuel_expense_included_in_job_price"
                             type="radio" value="1" /> YES
                    </label>
                    <label className="btn btn-secondary active"
                           id="no-driver-fuel-expense-included-in-job-price">
                      <input className="form-control form-control-lg"
                             name="driver_fuel_expense_included_in_job_price"
                             type="radio" value="0" /> NO
                    </label>
                  </div>
                </div>
              </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label>
                      Set Fleet Paperwork requirement as default
                    </label>

                    <div className="btn-group btn-group-toggle"
                         id="fleet-paperwork-form-radio-container"
                         data-toggle="buttons">
                      <label className="btn btn-secondary" id="yes-fleet-paperwork">
                        <input className="form-control form-control-lg"
                               name="vehicle_fleet_paperwork_required"
                               type="radio" value="1" required /> YES
                      </label>
                      <label
                        className="btn btn-secondary active"
                             id="no-fleet-paperwork">
                        <input className="form-control form-control-lg"
                               name="vehicle_fleet_paperwork_required" 
                               type="radio" value="0" required /> NO
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label>
                      Set Jet Wash as default
                    </label>

                    <div className="btn-group btn-group-toggle"
                         id="jet-wash-form-radio-container"
                         data-toggle="buttons">
                      <label className="btn btn-secondary"
                             id="yes-jet-wash">
                        <input className="form-control form-control-lg"
                               name="vehicle_jet_wash_required"
                               type="radio" value="1" required /> YES
                      </label>
                      <label className="btn btn-secondary active"
                             id="no-jet-wash">
                        <input className="form-control form-control-lg"
                               name="vehicle_jet_wash_required"
                               type="radio" value="0" required /> NO
                      </label>
                    </div>
                  </div>
                </div>
            </div>
            <hr />
                  <div className="row text-center">
                <div className="col-md-4">
                  <label>
                    Customer Provides Fuel Cost?
                  </label><br />

                  <div className="btn-group btn-group-toggle"
                       id="customer-provides-fuel-cost-form-radio-container"
                       data-toggle="buttons">
                    <label
                      className="btn btn-secondary"
                      id="yes-customer-provides-fuel-cost">
                      <input className="form-control form-control-lg"
                             name="customer_provides_fuel_cost"
                             type="radio" value="1" required /> YES
                    </label>
                    <label className="btn btn-secondary active"
                           id="no-customer-provides-fuel-cost">
                      <input className="form-control form-control-lg"
                             name="customer_provides_fuel_cost"
                             type="radio" value="0" required /> NO
                    </label>
                  </div>
                </div>
                <div className="col-md-4">
                  <label>
                    Customer Provides Mileage?
                  </label><br />
                  <div className="btn-group btn-group-toggle"
                       id="customer-provides-mileage-form-radio-container"
                       data-toggle="buttons">
                    <label
                      className="btn btn-secondary"
                      id="yes-customer-provides-mileage">
                      <input className="form-control form-control-lg"
                             name="customer_provides_mileage"
                             type="radio" value="1" required /> YES
                    </label>
                    <label
                      className="btn btn-secondary active"
                      id="no-customer-provides-mileage">
                      <input
                        className="form-control form-control-lg"
                        name="customer_provides_mileage"
                        type="radio"
                        value="0"
                        required /> NO
                    </label>
                  </div>
                </div>
                <div className="col-md-4">
                  <label>
                    Customer Provides Job Price?
                  </label><br />
                  <div className="btn-group btn-group-toggle"
                       id="customer-provides-job-price-form-radio-container"
                       data-toggle="buttons">
                    <label
                      className="btn btn-secondary active"
                      id="yes-customer-provides-job-price">
                      <input className="form-control form-control-lg"
                             name="customer_provides_job_price"
                             type="radio" value="1" required /> YES
                    </label>
                    <label
                      className="btn btn-secondary"
                      id="no-customer-provides-job-price">
                      <input className="form-control form-control-lg"
                             name="customer_provides_job_price"
                             type="radio" value="0" required /> NO
                    </label>
                  </div>
                </div>
                  </div>
            <hr />
                    <div className="row text-center">
                      <div className="col-md-4">
                        <label>
                          Job Prices Rounded up?
                        </label><br />

                        <div className="btn-group btn-group-toggle"
                             id="job-price-rounded-up-form-radio-container"
                             data-toggle="buttons">
                          <label
                            className="btn btn-secondary"
                            id="yes-job-price-rounded-up">
                            <input className="form-control form-control-lg"
                                   name="job_price_rounded_up"
                                   type="radio" value="1" required /> YES
                          </label>
                          <label className="btn btn-secondary active"
                                 id="no-job-price-rounded-up">
                            <input className="form-control form-control-lg"
                                   name="job_price_rounded_up"
                                   type="radio" value="0" required /> NO
                          </label>
                        </div>


              </div>
                      <div className="col-md-4">
                        <div className="form-group text-center">
                          <label>
                            Manual Appraisal Required?
                          </label>

                          <div className="btn-group btn-group-toggle"
                               id="manual-appraisal-required-form-radio-container"
                               data-toggle="buttons">
                            <label className="btn btn-secondary active"
                                   id="yes-manual-appraisal-required">
                              <input className="form-control form-control-lg"

                                     name="manual_appraisal_required"
                                     type="radio" value="1" /> YES
                            </label>
                            <label className="btn btn-secondary"
                                   id="no-manual-appraisal-required">
                              <input className="form-control form-control-lg"
                                     name="manual_appraisal_required"
                                     type="radio" value="0" /> NO
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group text-center">
                          <label>
                            Video Appraisal Required?
                          </label>

                          <div className="btn-group btn-group-toggle"
                               id="video-appraisal-required-form-radio-container"
                               data-toggle="buttons">
                            <label className="btn btn-secondary"
                                   id="yes-video-appraisal-required">
                              <input className="form-control form-control-lg"

                                     name="video_appraisal_required"
                                     type="radio" value="1" /> YES
                            </label>
                            <label className="btn btn-secondary active"
                                   id="no-video-appraisal-required">
                              <input className="form-control form-control-lg"
                                     name="video_appraisal_required"
                                     type="radio" value="0" /> NO
                            </label>
                          </div>
                        </div>
                      </div>
            </div>
            <hr />
            <div className="row text-center">
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="appraisal_to_be_done_on_external_system">
                    Is the appraisal to be done on an external system?
                  </label>
                  <div className="btn-group btn-group-toggle"
                       id="appraisal-to-be-done-on-external-system-form-radio-container"
                       data-toggle="buttons">
                    <label className="btn btn-secondary"
                           id="yes-appraisal-to-be-done-on-external-system"
                    onClick={(e) => {
                      this.setState({
                        showNameOfExternalSystemFormFields:
                        true
                      });
                    }}
                    >
                      <input className="form-control form-control-lg"
                             name="appraisal_to_be_done_on_external_system"
                             type="radio" value="1" /> YES
                    </label>
                    <label className="btn btn-secondary active"
                           id="no-appraisal-to-be-done-on-external-system"
                           onClick={(e) => {
                             this.setState({
                               showNameOfExternalSystemFormFields:
                               false
                             });
                           }}
                    >
                      <input className="form-control form-control-lg active"
                             name="appraisal_to_be_done_on_external_system"
                             type="radio" value="0" /> NO
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="customer_vat_code">
                    Is the customer to be charged VAT ?
                  </label>
                  <div className="btn-group btn-group-toggle"
                       id="customer-vat-code-form-radio-container"
                       data-toggle="buttons">
                    <label className="btn btn-secondary"
                           id="yes-customer-vat-code-form-radio-container"
                    onClick={(e) => {
                      this.setState({
                        showNameOfExternalSystemFormFields:
                        true
                      });
                    }}
                    >
                      <input className="form-control form-control-lg"
                             name="customer_vat_code"
                             type="radio" value="ct1" /> YES
                    </label>
                    <label className="btn btn-secondary active"
                           id="no-customer-vat-code-form-radio-container"
                           onClick={(e) => {
                             this.setState({
                               showNameOfExternalSystemFormFields:
                               false
                             });
                           }}
                    >
                      <input className="form-control form-control-lg active"
                             name="customer_vat_code"
                             type="radio" value="ct0" /> NO
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="customer_needs_expenses">
                    The customer required the following documents.
                  </label>
                  <div className="btn-group btn-group-toggle"
                       id="customer-needs-expenses-form-radio-container"
                       data-toggle="buttons">
                    <label className="btn btn-secondary active"
                           id="pod-customer-needs-expenses" onClick={(e) => {
                            this.setState({
                              showNameOfExternalSystemFormFields:
                              true
                            });
                          }}>
                      <input className="form-control form-control-lg"
                             name="customer_needs_expenses_pod"
                             type="checkbox" value="pod" /> POD
                    </label>
                    <label className="btn btn-secondary"
                           id="poc-customer-needs-expenses" onClick={(e) => {
                            this.setState({
                              showNameOfExternalSystemFormFields:
                              false
                            });
                          }}>
                      <input className="form-control form-control-lg"
                             name="customer_needs_expenses_poc"
                             type="checkbox" value="poc" /> POC
                    </label>
                    <label className="btn btn-secondary"
                           id="fuel-customer-needs-expenses" onClick={(e) => {
                            this.setState({
                              showNameOfExternalSystemFormFields:
                              false
                            });
                          }}>
                      <input className="form-control form-control-lg"
                             name="customer_needs_expenses_fuel"
                             type="checkbox" value="fuel" /> Fuel
                    </label>
                    <label className="btn btn-secondary"
                           id="expeses-customer-needs-expenses" onClick={(e) => {
                            this.setState({
                              showNameOfExternalSystemFormFields:
                              false
                            });
                          }}>
                      <input className="form-control form-control-lg"
                             name="customer_needs_expenses_all"
                             type="checkbox" value="expense" /> All Expenses
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-md-4 text-left">
                {(this.state.showNameOfExternalSystemFormFields) ?
                  <Animate
                    play={this.state.play}
                    start={{opacity: 0}}
                    end={{opacity: 1}}
                  >
                    <div className="form-group">
                      <label htmlFor="name_of_external_system_for_appraisal">
                        What is name of the external system?
                      </label>
                      <input
                        name="name_of_external_system_for_appraisal"
                        id="name_of_external_system_for_appraisal"
                        className="form-control form-control-lg"
                      />
                    </div>
                  </Animate>
                  : null}
              </div>
            </div>
            <hr />
              <div className="text-center">
                <button className="btn btn-lg btn-primary"
                        onClick={this.onAddNewCustomerCreate}
                        type="button">
                  <i className="fa fa-plus-circle"></i>&nbsp;
                  Add New Customer
                </button>

            </div>
          </fieldset>
        </form>
      </div>);
  }
  }

  if (document.getElementById(
  'react-component-g4-logistics-portal-customers-add-new-customer')) {
    ReactDOM.render(
      <AddNewCustomer />,
      document.getElementById(
        'react-component-g4-logistics-portal-customers-add-new-customer'
      )
    );
  }
